import type { UseCase } from '@/core/shared'
import type { StripeRepository } from '@/core/stripe'

export const hasPaymentsAccount: UseCase<StripeRepository, 'hasPaymentsAccount'> = repository => {
  return async (groupUid) => {
    return await repository.hasPaymentsAccount(groupUid)
  }
}
